var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames);
    global.SocialMedia = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SocialMedia = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(SocialMedia, _Component);

    var _super = _createSuper(SocialMedia);

    (0, _createClass2.default)(SocialMedia, null, [{
      key: "init",
      value: function init() {
        // inject the twitter sdk required to display embedded tweets
        if (SocialMedia.isTwitter) {
          /* global document */
          var script = document.createElement('script');
          script.src = '//platform.twitter.com/widgets.js';
          script.charset = 'utf-8';
          script.async = true;
          document.body.appendChild(script);
        }
      }
    }]);

    function SocialMedia(props) {
      var _this;

      (0, _classCallCheck2.default)(this, SocialMedia);
      _this = _super.call(this, props);
      var mediaType = '';

      if (props.html.indexOf('<blockquote class="twitter-tweet"') >= 0) {
        SocialMedia.isTwitter = true;
        mediaType = 'tweet';
      } else if (props.html.indexOf('<iframe src="https://www.facebook.com/plugins/post.php') >= 0) {
        mediaType = 'fb-post';
      } else if (props.html.indexOf('<iframe src="https://www.facebook.com/plugins/video.php') >= 0) {
        mediaType = 'fb-video';
      }

      _this.state = {
        mediaType: mediaType
      };
      return _this;
    }

    (0, _createClass2.default)(SocialMedia, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('article-social-media', this.state.mediaType),
          dangerouslySetInnerHTML: {
            __html: this.props.html
          }
        });
      }
    }]);
    return SocialMedia;
  }(_react.Component);

  (0, _defineProperty2.default)(SocialMedia, "isTwitter", false);
  SocialMedia.propTypes = {
    html: _propTypes.default.string.isRequired
  };
  SocialMedia.defaultProps = {
    html: ''
  };
  var _default = SocialMedia;
  _exports.default = _default;
});